import Stack from "@mui/material/Stack";
import { ModuleType, ModuleLayout } from "entities/modules/types";
import { getLayoutOptionsByType } from "modules/moduleTemplates/components/ModuleDetailsDrawer/context/utils";
import { useGeneralData } from "modules/moduleTemplates/components/ModuleDetailsDrawer/stores/useGeneralData";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import Select from "shared/components/Form/Select";
import Switch from "shared/components/Form/Switch";
import { COLOR_BLACK } from "shared/theme/colors";
import { assureValidLayout } from "../../utils";

const LayoutModuleSection = () => {
  const {
    moduleType,
    moduleLayout,
    studioFilterEnabled,
    setModuleLayout,
    setStudioFilterEnabled,
  } = useGeneralData();

  const shouldShowStudioFilter = moduleType === ModuleType.Games;

  const layoutOptions = moduleType
    ? getLayoutOptionsByType({
        moduleType: moduleType,
        studioFilterEnabled,
      })
    : [];

  const handleLayoutChange = (value: string) => {
    setModuleLayout(value as ModuleLayout);
  };

  const handleStudioFilterChange = (checked: boolean) => {
    setStudioFilterEnabled(checked);
    assureValidLayout({
      moduleType,
      studioFilterEnabled: checked,
      moduleLayout,
      setModuleLayout,
    });
  };

  return (
    <ContentSection title="MODULE CONFIGURATION">
      <Stack spacing="1rem">
        {shouldShowStudioFilter && (
          <Switch
            value={studioFilterEnabled}
            onChange={handleStudioFilterChange}
            label="Insert studio filter buttons"
          />
        )}
        <Select
          id="moduleLayout"
          label="Layout"
          labelColor={COLOR_BLACK}
          placeholder="Select a layout"
          disabledPlaceholder
          fullWidth
          required
          value={moduleLayout ?? undefined}
          handleChange={handleLayoutChange}
          options={layoutOptions}
        />
      </Stack>
    </ContentSection>
  );
};

export default LayoutModuleSection;
